import React from 'react';
import FilterBar from '../../components/filters/FilterBar';
import PageLayout from '../../components/layout/PageLayout';
import ErrorBoundary from '../../components/ui/ErrorBoundary';
import UserLifecycle from '../../components/users/UserLifecycle';
import { useFilterPersistence } from '../../hooks/useFilterPersistence';
import { PAGE_INFO, FILTER_PERIODS } from '../../constants';
import './Lifecycle.css';

/**
 * User Lifecycle Page Component
 * Track user progression through signup to active user
 */
const LifecyclePage = () => {
  const { period, setPeriod } = useFilterPersistence({
    pageKey: 'user-lifecycle',
    defaultPeriod: FILTER_PERIODS.ALL
  });

  const filters = (
    <FilterBar
      period={period}
      onPeriodChange={setPeriod}
    />
  );

  return (
    <ErrorBoundary>
      <PageLayout
        title={PAGE_INFO.USER_LIFECYCLE.title}
        description={PAGE_INFO.USER_LIFECYCLE.description}
        filters={filters}
      >
        <div className="lifecycle-content">
          <UserLifecycle period={period} />
        </div>
      </PageLayout>
    </ErrorBoundary>
  );
};

export default LifecyclePage;

